import { COLORS } from "../../../constants";
import { DEFAULT_SHADOW, HALO } from "../../../constants/colors";
export var iconButtonStyles = {
    // SVG
    ".MuiSvgIcon-root": {
        color: COLORS.P_HIGH_EMPHASIS,
    },
    // Button medium
    "&.MuiIconButton-sizeMedium": {
        p: 2.5,
    },
    // Button small
    "&.MuiIconButton-sizeSmall": {
        p: 1.5,
    },
    "&.MuiIconButton-selected": {
        bgcolor: "".concat(COLORS.OVERLAY_SELECTED, " !important"),
        ".MuiSvgIcon-root": {
            color: "primary.main",
        },
    },
    "&.Mui-disabled": {
        ".MuiSvgIcon-root": {
            color: COLORS.P_DISABLED,
        },
    },
    "&:focus-visible": {
        bgcolor: "primary.contrastText",
        boxShadow: HALO,
        ".MuiTouchRipple-root": {
            display: "none",
        },
    },
    "&.MuiIconButton-dragged": {
        boxShadow: DEFAULT_SHADOW,
        ".MuiTouchRipple-root": {
            display: "none",
        },
    },
    "&:hover": {
        bgcolor: COLORS.SECONDARY_HOVER,
    },
    ".MuiCircularProgress-root": {
        color: "secondary.contrastText",
    },
    // darkmode
    "&.MuiIconButton-dark": {
        "&.MuiIconButton-selected": {
            bgcolor: "".concat(COLORS.OVERLAY_SELECTED, " !important"),
            ".MuiSvgIcon-root": {
                color: "primary.main",
            },
        },
        ".MuiSvgIcon-root": {
            color: COLORS.S_HIGH_EMPHASIS,
        },
        "&:hover": {
            bgcolor: COLORS.DARK_HOVER,
        },
        "&:active, &.MuiIconButton-dragged": {
            bgcolor: COLORS.DARK_PRESSED,
        },
        ".MuiCircularProgress-root": {
            color: "primary.contrastText",
        },
    },
    // ctaAlt
    "&.MuiIconButton-ctaAlt": {
        bgcolor: "secondary.main",
        "&:hover": {
            bgcolor: COLORS.SECONDARY_HOVER,
        },
        ".MuiSvgIcon-root": {
            color: "primary.main",
        },
        "&.Mui-disabled": {
            ".MuiSvgIcon-root": {
                color: COLORS.P_DISABLED,
            },
        },
        ".MuiCircularProgress-root": {
            color: "secondary.contrastText",
        },
    },
};
